export const replaceWithMarkup = (
  str: string,
  secondColor = "text-primary-100"
) => {
  return str
    .replace(/\|/g, `<br class="block" />`)
    .replace(/\*\*(.*?)\*\*/g, `<span class="${secondColor}">$1</span>`);
};
